async function addFile(url, files) {
  try {
    if (url && url.startsWith('blob:'))
      files[url] = await fetch(url).then(r => r.blob());
  } catch (e) {
    console.error('Failed to load blob');
  }
}

async function getBlobMediaFiles(card) {
  const files = {};
  await addFile(card?.background?.img, files);
  for (const page of (card?.pages || [])) {
    for (const blob of page.blobs) {
      if (blob.type == 'IMG')
        await addFile(blob.img.src, files);
      else if (blob.type == 'VIDEO')
        await addFile(blob.video.src, files);
    }
  }
  return files;
}

export default getBlobMediaFiles;
